import { render, staticRenderFns } from "./Cx3PbxWizard.vue?vue&type=template&id=28b6c61a&"
import script from "./Cx3PbxWizard.vue?vue&type=script&lang=js&"
export * from "./Cx3PbxWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports